import { SDS_SIZE_XXXXXSMALL, SDS_SIZE_XXXXSMALL, SDS_SIZE_XXXSMALL, SDS_SIZE_MEDIUM, SDS_SIZE_XXXLARGE, SDS_SIZE_XXXXXLARGE } from '@s-group/design-system-tokens/web/tokens/size.es6.js';

// The indicator circle radius used in `defaultProps` internally.
const SVG_CIRCLE_RADIUS = 10;
// The indicator bar width used only internally in SVG. We can use same stroke
// calculation logic in bar and circle indicators, if the bar width equals with
// the circle circumference.
const SVG_BAR_WIDTH = Math.PI * 2 * SVG_CIRCLE_RADIUS;
// Amount of whitespace around the circle. This is rendered as part of the SVG
// image, as it should scale proptionally, when the whole SVG image is scaled.
const SVG_CIRCLE_WHITESPACE = 2;
// Visible circle stroke width inside the perimeter of the circle.
const SVG_STROKE_WIDTH = 1.5;
// These angle constants are used to define stroke lenghts as angles in polar
// coordinates. Values of the constants are defined in radians.
const ANGLE_0 = 0;
const ANGLE_90 = Math.PI / 2;
const ANGLE_180 = Math.PI;
const ANGLE_270 = (Math.PI * 3) / 2;
const ANGLE_360 = Math.PI * 2;
// Standard sizes for bar indicator
const BarIndicatorSize = {
    small: SDS_SIZE_XXXXXSMALL,
    medium: SDS_SIZE_XXXXSMALL,
    large: SDS_SIZE_XXXSMALL,
};
// Stadard sizes for circular indicator
const CircularIndicatorSize = {
    small: SDS_SIZE_MEDIUM,
    medium: SDS_SIZE_XXXLARGE,
    large: SDS_SIZE_XXXXXLARGE,
};
const defaultProps = {
    size: 'small',
    type: 'circle',
};

export { ANGLE_0, ANGLE_180, ANGLE_270, ANGLE_360, ANGLE_90, BarIndicatorSize, CircularIndicatorSize, SVG_BAR_WIDTH, SVG_CIRCLE_RADIUS, SVG_CIRCLE_WHITESPACE, SVG_STROKE_WIDTH, defaultProps };
//# sourceMappingURL=constants.js.map
